module.exports = __webpack_public_path__ + "static/img/LU.7dfddee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/LU.svg
// module id = P4Cw
// module chunks = 1